import { combineReducers } from 'redux'

import flashMessages from './reducers/flashMessages'
import auth from './reducers/auth'
import orders from './reducers/orders'
import calendar from './reducers/calendar'
import comps from './reducers/comps'
import sttss from './reducers/sttss'
import empls from './reducers/empls'
import percs from './reducers/percs'
import places from './reducers/places'
import ptypes from './reducers/ptypes'
import etypes from './reducers/etypes'
import products from './reducers/products'
import posts from './reducers/posts'
import expenses from './reducers/expenses'
import invcs from './reducers/invcs'
import files from './reducers/files'
import filetypes from './reducers/filetypes'
import links from './reducers/links'
import srvcs from './reducers/srvcs'
import requs from './reducers/requs'
import srvgs from './reducers/srvgs'
import ctypes from './reducers/ctypes'
import srvms from './reducers/srvms'
import settings from './reducers/settings'
import dataState from './reducers/dataState'
import reports from './reducers/reports'
import actions from './reducers/actions'
import atypes from './reducers/atypes'
import rights from './reducers/rights'
import usrgs from './reducers/usrgs'
import comprights from './reducers/comprights'
import orgs from './reducers/orgs'
import todolists from './reducers/todolists'
import todolistsDefault from './reducers/todolistsDefault'
import todos from './reducers/todos'
import users from './reducers/users'
import bsnss from './reducers/bsnss'
import sakhs from './reducers/sakhs'

const appReducer = combineReducers({
  actions,
  atypes,
  auth,
  bsnss,
  calendar,
  comprights,
  comps,
  ctypes,
  dataState,
  empls,
  etypes,
  products,
  expenses,
  files,
  filetypes,
  flashMessages,
  invcs,
  links,
  orders,
  orgs,
  percs,
  places,
  ptypes,
  posts,
  reports,
  requs,
  rights,
  sakhs,
  settings,
  srvcs,
  srvgs,
  srvms,
  sttss,
  todolists,
  todolistsDefault,
  todos,
  users,
  usrgs
})

const rootReducer = (state, action) => {
  if (action.type === 'USER_LOGOUT') {
    state = undefined;
  }
  return appReducer(state, action);
}

export default rootReducer;



// WEBPACK FOOTER //
// ./src/rootReducer.js